var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg087Cut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.466,313.044c-44.94,0-83.015,29.957-95.309,70.953l-36.107-48.98l103.696-140.045 c6.572-8.875,4.705-21.396-4.171-27.969c-8.873-6.57-21.396-4.703-27.969,4.171L194.902,384.16 c-12.233-41.077-50.357-71.115-95.366-71.115c-54.852,0-99.478,44.63-99.478,99.488c0,54.847,44.626,99.468,99.478,99.468 c35.408,0,66.555-18.594,84.187-46.54c1.237-1.019,2.37-2.203,3.366-3.548l69.063-93.272l68.734,93.238 c0.999,1.355,2.137,2.546,3.378,3.571c17.63,27.947,48.783,46.551,84.2,46.551c54.852,0,99.478-44.621,99.478-99.507 C511.943,357.656,467.318,313.044,412.466,313.044z M99.536,472.009c-32.802,0-59.487-26.682-59.487-59.477 c0-32.806,26.685-59.497,59.487-59.497s59.487,26.673,59.487,59.497C159.023,445.327,132.338,472.009,99.536,472.009z  M412.466,472.009c-32.802,0-59.487-26.682-59.487-59.477c0-32.806,26.685-59.497,59.487-59.497 c32.802,0,59.487,26.673,59.487,59.497C471.952,445.327,445.267,472.009,412.466,472.009z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.592,120.058L193.267,282.64c3.748,5.091,9.682,8.109,16.003,8.142h0.1c6.285,0,12.205-2.955,15.983-7.981 L401.52,48.41c11.375,13.743,13.992,33.59,5.062,50.222c-5.224,9.729-1.572,21.851,8.158,27.076 c9.729,5.224,21.852,1.57,27.076-8.158c22.116-41.191,6.676-92.836-34.42-115.128c-8.709-4.725-19.565-2.357-25.518,5.562 L255.583,176.018L132.138,8.259c-5.918-8.042-16.863-10.486-25.64-5.726c-41.094,22.294-56.534,73.94-34.418,115.129 C72.526,118.495,73.032,119.296,73.592,120.058z M112.237,48.69L230.495,209.4l-20.957,27.884L106.717,97.598 C98.539,81.275,101.236,62.112,112.237,48.69z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg087Cut);
export default __webpack_public_path__ + "static/media/087-cut.145e32c3979aacc115854782cba1ff87.svg";
export { ForwardRef as ReactComponent };